export default __webpack_public_path__ + "static/media/sc-logo-300dpi.e8198564.png";